import React from 'react';
import { Flag } from 'lucide-react';

/**
 * Customer flag badge — renders THREE flags of the given colour.
 *   - `red`   → three red flags   (Suspicious customer)
 *   - `green` → three green flags (Premium customer)
 *   - falsy   → nothing
 *
 * Optional `size` (default 14) and `title` for accessibility.
 */
const FlagIcons = ({ flag, size = 14, title }) => {
  if (!flag) return null;
  const color = flag === 'red' ? '#dc2626' : '#16a34a';
  const label = title || (flag === 'red' ? 'Suspicious customer' : 'Premium customer');
  return (
    <span
      className="inline-flex items-center gap-[1px] align-middle"
      title={label}
      data-testid={`flag-icons-${flag}`}
      aria-label={label}
    >
      <Flag size={size} fill={color} color={color} strokeWidth={2} />
      <Flag size={size} fill={color} color={color} strokeWidth={2} />
      <Flag size={size} fill={color} color={color} strokeWidth={2} />
    </span>
  );
};

export default FlagIcons;
